export enum BillableItemStatus {
    FACTURABLE = 1,
    NO_FACTURABLE = 2,
    FACTURABLE_BONIFICADO = 3
}

export const getBillableItemStatusDescription = (status: number): string => {
    switch (status) {
        case BillableItemStatus.FACTURABLE:
            return 'Facturable';
        case BillableItemStatus.NO_FACTURABLE:
            return 'No Facturable';
        case BillableItemStatus.FACTURABLE_BONIFICADO:
            return 'Facturable Bonificado';
        default:
            return 'Desconocido';
    }
};

export const billableItemStatusOptions = [
    { value: BillableItemStatus.FACTURABLE, label: 'Facturable' },
    { value: BillableItemStatus.NO_FACTURABLE, label: 'No Facturable' },
    { value: BillableItemStatus.FACTURABLE_BONIFICADO, label: 'Facturable Bonificado' }
];
